import { createI18n } from 'vue-i18n/index'

const i18n = createI18n({
    legacy: false,
    locale: JSON.parse(localStorage.getItem('vuex'))?.language || 'EN',
    globalInjection: true,
    messages: {
    },

})

export default i18n;